import {
  AiResponseSummaryDtoStatusEnum,
  PromptConfigOutputDtoScopeEnum,
} from '@kortxio/hub-api';
import { useKampusQueryParam } from 'libs/hooks';
import {
  createEnumParam,
  DateParam,
  NumberParam,
  StringParam,
} from 'use-query-params';

const allScopes = Object.values(
  PromptConfigOutputDtoScopeEnum
) as PromptConfigOutputDtoScopeEnum[];

const allStatuses = Object.values(
  AiResponseSummaryDtoStatusEnum
) as AiResponseSummaryDtoStatusEnum[];

export const ScopeQueryParam = createEnumParam(allScopes);
export const StatusQueryParam = createEnumParam(allStatuses);

export const aiResponsesScopeParamName = 'scope';
export const aiResponsesPromptIdParamName = 'promptId';
export const aiResponsesVersionParamName = 'version';
export const aiResponsesStatusParamName = 'status';
export const aiResponsesQueryParamName = 'q';
export const aiResponsesFromDateParamName = 'fromDate';
export const aiResponsesToDateParamName = 'toDate';
export const aiResponsesResponseIdParamName = 'responseId';

export const aiResponsesParamConfigMap = {
  [aiResponsesScopeParamName]: ScopeQueryParam,
  [aiResponsesPromptIdParamName]: StringParam,
  [aiResponsesVersionParamName]: NumberParam,
  [aiResponsesStatusParamName]: StatusQueryParam,
  [aiResponsesQueryParamName]: StringParam,
  [aiResponsesFromDateParamName]: DateParam,
  [aiResponsesToDateParamName]: DateParam,
  [aiResponsesResponseIdParamName]: StringParam,
};

export const useScopeSearchParam = () =>
  useKampusQueryParam(aiResponsesScopeParamName, ScopeQueryParam);

export const usePromptIdSearchParam = () =>
  useKampusQueryParam(aiResponsesPromptIdParamName, StringParam);

export const useVersionSearchParam = () =>
  useKampusQueryParam(aiResponsesVersionParamName, NumberParam);

export const useStatusSearchParam = () =>
  useKampusQueryParam(aiResponsesStatusParamName, StatusQueryParam);

export const useQuerySearchParam = () =>
  useKampusQueryParam(aiResponsesQueryParamName, StringParam);

export const useFromDateSearchParam = () =>
  useKampusQueryParam(aiResponsesFromDateParamName, DateParam);

export const useToDateSearchParam = () =>
  useKampusQueryParam(aiResponsesToDateParamName, DateParam);

export const useResponseIdSearchParam = () =>
  useKampusQueryParam(aiResponsesResponseIdParamName, StringParam);
